"use strict";
// @ts-ignore
try {
    self['workbox:range-requests:6.1.5'] && _();
}
catch (e) { }
